import type { ApolloError } from 'apollo-client';

import FeatureGates from '@atlaskit/feature-gate-js-client';

import { useApiBillingInformation } from './useApiBillingInformation';
import { useIsAccountInvoiceable } from './useIsAccountInvoiceable';

export interface UseHasBillingInformationResponse {
	hasBillingInformation: boolean;
	loading: boolean;
	error: Error | ApolloError | null;
}

export const useHasBillingInformation = (
	skip: boolean = false,
): UseHasBillingInformationResponse => {
	const isAggAccountInvoiceableEnabled = FeatureGates.checkGate(
		'cc_onboarding_account_invoiceable_agg_check',
	);

	const invoiceableResponse = useIsAccountInvoiceable(skip || !isAggAccountInvoiceableEnabled);
	const billingResponse = useApiBillingInformation(skip || isAggAccountInvoiceableEnabled);

	if (skip) {
		return {
			hasBillingInformation: false,
			loading: false,
			error: null,
		};
	}

	if (isAggAccountInvoiceableEnabled) {
		return {
			hasBillingInformation: invoiceableResponse.isAccountInvoiceable,
			loading: invoiceableResponse.loading,
			error: invoiceableResponse.error,
		};
	} else {
		return {
			hasBillingInformation: billingResponse.hasBillingInformation,
			loading: billingResponse.loading,
			error: billingResponse.error,
		};
	}
};
